import React, { createContext, useCallback, useContext, useMemo } from 'react';
const CollapseActionsContext = /*#__PURE__*/createContext(null);
const ItemScopeContext = /*#__PURE__*/createContext(null);
export const CollapseActionsProvider = _ref => {
  let {
    setOpenItems,
    children
  } = _ref;
  const openItem = useCallback(id => {
    setOpenItems(prev => {
      if (prev.has(id)) {
        return prev;
      }
      const next = new Set(prev);
      next.add(id);
      return next;
    });
  }, [setOpenItems]);
  const closeItem = useCallback(id => {
    setOpenItems(prev => {
      if (!prev.has(id)) {
        return prev;
      }
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  }, [setOpenItems]);
  const toggleItem = useCallback(id => {
    setOpenItems(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, [setOpenItems]);
  const value = useMemo(() => ({
    closeItem,
    openItem,
    toggleItem
  }), [openItem, closeItem, toggleItem]);
  return /*#__PURE__*/React.createElement(CollapseActionsContext.Provider, {
    value: value
  }, children);
};
export const ItemScopeProvider = _ref2 => {
  let {
    id,
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement(ItemScopeContext.Provider, {
    value: id
  }, children);
};
export const useCollapseActions = () => {
  const ctx = useContext(CollapseActionsContext);
  if (!ctx) {
    throw new Error('useCollapseActions must be used within CollapseActionsProvider');
  }
  return ctx;
};
export const useCloseSelf = () => {
  const {
    closeItem
  } = useCollapseActions();
  const id = useContext(ItemScopeContext);
  return useCallback(() => {
    if (id) {
      closeItem(id);
    }
  }, [closeItem, id]);
};
//# sourceMappingURL=collapse-actions-context.js.map